import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2880a924"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "annotations",
  ref: "annotationsDiv"
}
const _hoisted_2 = { class: "connection-lines" }
const _hoisted_3 = { class: "connecting-lines-group" }

import {PropType, Ref} from "vue";
import DotAnnotation from "@/components/frame/image/annotation/DotAnnotation.vue";
import ConnectionLine from "@/components/frame/image/annotation/ConnectionLine.vue";
import {SSegmentedTarget} from "@/store/Spatial2DAnnotation/model/SSegmentedTarget";
import {S2DSegment} from "@/store/Spatial2DAnnotation/model/S2DSegment";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'DotAnnotations',
  props: {
  dotAnnotations: {
    type: Array as PropType<S2DSegment[]>,
    required: true,
  },
  parentTarget: {
    type: Object as PropType<SSegmentedTarget>,
    required: true,
  },
  parentOverlayRef: {
    type: Object as PropType<Ref<HTMLElement>>,
    required: true,
  },
  forceConnectingLineRedraw: Number,
  undisplayConnectingLinesOfDotAnnotationsIndex: Number,
},
  emits: ["onHoveredAnnotations"],
  setup(__props, { emit: emits }) {

const props = __props






// ------------------------------
//  Annotations hover handling
// ------------------------------

const hoveredAnnotations: S2DSegment[] = [];

const onDotAnnotationMouseOver = (annotation: S2DSegment) => {
  if (!hoveredAnnotations.filter(hoveredAnnotation => hoveredAnnotation.instanceId === annotation.instanceId).length)
  {
    hoveredAnnotations.push(annotation);
    emits("onHoveredAnnotations", hoveredAnnotations)
  }
}

const onDotAnnotationMouseLeave = (annotation: S2DSegment) =>
{
  if (hoveredAnnotations.filter(hoveredAnnotation => hoveredAnnotation.instanceId === annotation.instanceId).length)
  {
    hoveredAnnotations.splice(hoveredAnnotations.findIndex(hoveredAnnotation => hoveredAnnotation.instanceId === annotation.instanceId), 1)
    emits("onHoveredAnnotations", hoveredAnnotations)
  }
}

const isConnectingLineDisplayed = (index: number): boolean =>
{
  return (typeof props.undisplayConnectingLinesOfDotAnnotationsIndex === 'undefined' || (index - 1) !== props.undisplayConnectingLinesOfDotAnnotationsIndex)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dotAnnotations, (dotAnnotation, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "dot-annotations-container",
        key: dotAnnotation.instanceId
      }, [
        _createVNode(DotAnnotation, {
          "dot-annotation": dotAnnotation,
          "parent-overlay-ref": __props.parentOverlayRef,
          "parent-target": __props.parentTarget,
          "is-first": index === 0,
          onOnTrueMouseover: onDotAnnotationMouseOver,
          onOnTrueMouseleave: onDotAnnotationMouseLeave
        }, null, 8, ["dot-annotation", "parent-overlay-ref", "parent-target", "is-first"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dotAnnotations, (dotAnnotation, index) => {
          return _withDirectives((_openBlock(), _createBlock(ConnectionLine, {
            key: index,
            color: __props.parentTarget.colorCode,
            "from-element-id": 'dot-annotation-' + __props.dotAnnotations[index === 0 ? 0 : index - 1].instanceId + '-' + __props.dotAnnotations[index === 0 ? 0 : index - 1].type,
            "to-element-id": 'dot-annotation-' + dotAnnotation.instanceId + '-' + dotAnnotation.type,
            "force-redraw": __props.forceConnectingLineRedraw
          }, null, 8, ["color", "from-element-id", "to-element-id", "force-redraw"])), [
            [_vShow, isConnectingLineDisplayed(index)]
          ])
        }), 128)),
        (__props.parentTarget.isCompleted)
          ? _withDirectives((_openBlock(), _createBlock(ConnectionLine, {
              key: 0,
              color: __props.parentTarget.colorCode,
              "from-element-id": 'dot-annotation-' + __props.dotAnnotations[__props.dotAnnotations.length - 1].instanceId + '-' + __props.dotAnnotations[__props.dotAnnotations.length - 1].type,
              "to-element-id": 'dot-annotation-' + __props.dotAnnotations[0].instanceId + '-' + __props.dotAnnotations[0].type,
              "force-redraw": __props.forceConnectingLineRedraw
            }, null, 8, ["color", "from-element-id", "to-element-id", "force-redraw"])), [
              [_vShow, isConnectingLineDisplayed(__props.dotAnnotations.length)]
            ])
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}
}

})